import { fromJS } from 'immutable'
import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAILURE,
  USER_LIST_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case USER_LIST_SUCCESS:
      return state
        .set('listUser', fromJS(action.payload.users))
        .set('status', action.payload.ok)
        .set('isFetching', false)
    case USER_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case USER_LIST_RESET:
      return state
        .delete('listUser')
        .delete('status')
        .delete('redirect')
        .delete('isAuthenticated')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-list-reducer.js